import React from "react";
import "./Works.css";
import {Link} from 'react-scroll'
const Works = () => {
  const technologies = [
    "React",
    "JavaScript",
    "TypeScript",
    "Node.js",
    "Express",
    "MongoDB",
    "MySQL",
    "Firebase",
    "React Native",
    "Flutter",
    "Figma",
    "REST APIs",
    "Git",
    "Resend",
  ];
  const marqueeItems = [...technologies, ...technologies];

  return (
    <section className="works" id="works">
      <div className="section-copy">
        <span className="section-kicker">Technology stack</span>
        <h2>The tools I use to build complete web and mobile products.</h2>
        <p>
          My work sits between polished interfaces and dependable backend
          systems, with enough design fluency to keep every flow feeling neat.
        </p>
        <Link to="contact" smooth={true} spy={true}>
          <button className="button s-button">Hire Me</button>
        </Link>
      </div>
      <div className="tech-panel" aria-label="Technologies Sicelo uses">
        <div className="tech-marquee">
          {marqueeItems.map((technology, index) => (
            <span className="tech-chip" key={`${technology}-${index}`}>
              {technology}
            </span>
          ))}
        </div>
        <div className="tech-marquee tech-marquee-reverse">
          {marqueeItems.slice().reverse().map((technology, index) => (
            <span className="tech-chip" key={`${technology}-reverse-${index}`}>
              {technology}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Works;
